<template>
    <page-content>
        <div slot="header">
            <h4 class="page-title-padding">低分报表</h4>
            <el-button icon="el-icon-download" size="mini" type="primary" :loading="dowLoading" @click="downloadData">导出数据</el-button>
        </div>
        <div slot="content">
            <el-table v-loading="loading" @filter-change="filterChange" :data="tableData" max-height="780" show-summary :summary-method="getSummaries" size="mini">
                <el-table-column sortable prop="examinee_name" label="被考评人" header-align="center" align="center">
                </el-table-column>
                <el-table-column sortable prop="examiner_name" label="考评人" header-align="center" align="center">
                </el-table-column>
                <el-table-column sortable prop="leader_name" column-key="leader_name" :filters="filterData.leader_name || []" label="负责人" header-align="center" align="center">
                </el-table-column>
                <el-table-column sortable prop="position_name" column-key="position_name" :filters="filterData.position_name || []" label="岗位" header-align="center" align="center">
                </el-table-column>
                <el-table-column sortable prop="group_name" column-key="group_name" :filters="filterData.group_name || []" label="组别" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="department" column-key="department" :filters="filterData.department || []" label="部门" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="lostPoints" label="各项扣分明细" header-align="center" align="center" width="250">
                    <template slot-scope="scope" align-center>
                        <el-row>
                            <el-col :span="12" class="lostPointsLeft">考勤({{scope.row.lostPoints.attendanceMaxScore}}分):</el-col>
                            <el-col :span="12" class="lostPointsright">{{scope.row.lostPoints.attendanceLostPoints}}</el-col>
                            <el-col :span="12" class="lostPointsLeft">时间管理({{scope.row.lostPoints.timeManageMaxScore}}分):</el-col>
                            <el-col :span="12" class="lostPointsright">{{scope.row.lostPoints.timeManageLostPoints}}</el-col>
                            <el-col :span="12" class="lostPointsLeft">工作达成({{scope.row.lostPoints.workAccomplishedMaxScore}}分):</el-col>
                            <el-col :span="12" class="lostPointsright">{{scope.row.lostPoints.workAccomplishedLostPoints}}</el-col>
                            <el-col :span="12" class="lostPointsLeft">工作能力({{scope.row.lostPoints.workAbilityMaxScore}}分):</el-col>
                            <el-col :span="12" class="lostPointsright">{{scope.row.lostPoints.workAbilityLostPoints}}</el-col>
                            <el-col :span="12" v-if="scope.row.lostPoints.manageAbilityLostPoints!=null" class="lostPointsLeft">管理能力({{scope.row.lostPoints.manageAbilityMaxScore}}分):</el-col>
                            <el-col :span="12" v-if="scope.row.lostPoints.manageAbilityLostPoints!=null" class="lostPointsright">{{scope.row.lostPoints.manageAbilityLostPoints}}</el-col>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="additional_item" label="追加项得分" header-align="center" align="center">
                </el-table-column>
                <el-table-column sortable prop="score" label="分数" header-align="center" align="center">
                </el-table-column>
            </el-table>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import {computeAssessDate} from '@/assets/js/date'
import {downloadExcel} from '@/assets/js/exportdata'
import {multiFilter} from '@/assets/js/filtrate'
export default {
    data(){
        return {
            assessDate:'',
            tableData:[],
            loading:false,
            dowLoading:false,
            score:'95',
            filterData:[],                              //筛选数据
            initData:[],                                //初始数据
            tableFilter:[],                             //筛选条件数据
        }
    },
    created(){
        this.assessDate=computeAssessDate()[0].split('/');
        this.getInitData(this.score);
    },
    methods:{
        getInitData(score=''){                                     //初始数据
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                score,
            }
            this.loading=true;
            this.$http.get('/export/getAllDepartmentExportDataLow',{params:param}).then(v=>{
                if(v.status === 200 && v.data.status){
                    this.tableData=v.data.data;
                    this.initData=JSON.parse(JSON.stringify(v.data.data));
                    this.setAllFilterData(JSON.parse(JSON.stringify(v.data.data)));
                }
                this.loading=false;
            }).catch(v=>{this.loading=false;})
        },
        filterChange(data){                                         //筛选
            const initData = JSON.parse(JSON.stringify(this.initData));
            const val=Object.keys(data);
            if(this.tableFilter.length===0){        //保存全部筛选数据
                this.tableFilter.push(data)
            }else{
                let isKey=true;
                this.tableFilter.forEach((v,index)=>{
                    const $key=Object.keys(v)
                    if(val[0] === $key[0]) isKey=index;
                })
                isKey===true ? (this.tableFilter.push(data)) : (this.tableFilter.splice(isKey,1,data))
            }
            this.tableData=multiFilter(initData,this.tableFilter);
        },
        setAllFilterData(data){                                 //获得筛选数据
            let filterData={ //初始所需数据
                group_name:[],
                position_name:[],
                leader_name:[],
                department:[],
            };
            for(let i in filterData){
                data.forEach(v=>{
                    if(!filterData[i].some(item=>item.text===v[i])){
                        filterData[i].push({
                            text:v[i],
                            value:v[i],
                        });
                    }
                })
            }
            this.filterData=filterData;
        },
        downloadData(){                                         //导出数据
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                score:this.score,
            }
            this.dowLoading=true;                               
            downloadExcel('get','export/allDepartmentLow',{params:param},computeAssessDate()[0]+'期低分报表',v=>{
                this.dowLoading=false; 
            })
        },
        getSummaries(){                                         //页尾
            return [`共${this.tableData.length}条数据`]
        },
    },
    components:{
        pageContent
    },
}
</script>
<style scoped>
    .lostPointsLeft{
        text-align: right;
    }
    .lostPointsright{
        text-align: left;
        padding-left: 10px;
    }
</style>

